import { BASE_URL } from "../configs";
import { getAccessToken } from "../helpers/auth/token";
import { getQueryParamsString } from "../lib/utils";
import axiosInstance from "./axios"

export async function getUsers({ q, page, perPage, showArchived = false }) {
  let url = `${BASE_URL}/api/user?`;
  url += getQueryParamsString({ q, page, perPage, showArchived })

  const res = await axiosInstance.get(url)
  return res.data.Data;
}

export async function getUser(userId) {
  let url = `${BASE_URL}/api/users/${userId}`;

  const res = await axiosInstance.get(url)
  return res.data.Data;
}

export async function createUser(user) {
  let url = `${BASE_URL}/api/user`;

  const res = await axiosInstance.post(url, user)
  return res.data.Data;
}

export async function updateUser(user) {
  let url = `${BASE_URL}/api/user`;

  const res = await axiosInstance.put(url, user)
  return res.data.Data;
}

export async function deleteUser(userId) {
  let url = `${BASE_URL}/api/user/${userId}`;

  const res = await axiosInstance.delete(url)
  return res.data.Data;
}

export async function archiveUser(userId) {
  let url = `${BASE_URL}/api/user/archive/${userId}`;

  const res = await axiosInstance.post(url)
  return res.data.Data;
}

export async function unArchiveUser(userId) {
  let url = `${BASE_URL}/api/user/unarchive/${userId}`;

  const res = await axiosInstance.post(url)
  return res.data.Data;
}

export async function inviteUsers(users) {
  let url = `${BASE_URL}/api/user/invite`;

  const res = await axiosInstance.post(url, users)
  return res.data;
}

export async function deleteAccount(password) {
  var headers = new Headers();
  headers.set("Accept", "application/json");
  headers.set("Content-Type", "application/json");
  headers.set("Authorization", `Bearer ${getAccessToken()}`);

  let url = `${BASE_URL}/api/user/delete-account`;

  const response = await fetch(url, {
    method: "post",
    headers,
    credentials: "include",
    body: JSON.stringify({ password }),
  });

  const res = await response.json();
  return res;
}

export async function getUserCompanies() {
  var headers = new Headers();
  headers.set("Accept", "application/json");
  headers.set("Content-Type", "application/json");
  headers.set("Authorization", `Bearer ${getAccessToken()}`);

  let url = `${BASE_URL}/api/user/companies`;

  const response = await fetch(url, {
    method: "get",
    headers,
    credentials: "include",
  });

  if (response.status > 400) {
    throw response;
  }

  const res = await response.json();
  return res.Data;
}

export async function selectCompany(companyId) {
  var headers = new Headers();
  headers.set("Accept", "application/json");
  headers.set("Content-Type", "application/json");
  headers.set("Authorization", `Bearer ${getAccessToken()}`);

  let url = `${BASE_URL}/api/user/select-company`;

  const response = await fetch(url, {
    method: "post",
    headers,
    credentials: "include",
    body: JSON.stringify({ companyId }),
  });

  if (response.status > 400) {
    throw response;
  }

  const res = await response.json();
  return res.Data;
}

